import {Component} from 'react';
import { toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.min.css';

class Toast extends Component {

    show(data) {
        let type_icon = '';
        if(data.type === 'success'){
            type_icon = '😃 ';
        }else if(data.type === 'error'){
            type_icon = '😢 ';
        }else{
            type_icon = '😎 ';
        }
        toast.error(`${type_icon} ${data.message}`, {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: false,
            draggablePercent: 10,
            newestOnTop: false,
            closeOnClick: true,
            rtl: false,
            pauseOnVisibilityChange: true,
            draggable: true,
            pauseOnHover: true,
            progressClassName: 'toast',
            bodyClassName: 'toast-font'
        });
    };

    render() {
        return null;
    }
}

export default Toast;



// WEBPACK FOOTER //
// ./src/components/extras/Toast.js